import http from "@/common/http-common";
import store from '@/store';

class AuthService {
  async login(username, password) {
    const loginData = {
      login: username,
      password: password
    }

    return await http().post("/api/v1/users/login", loginData).then(function(resp) { // api call
      console.log("Inside UserService.login, resp ==> ", resp);
      const user = resp.data;
      console.log("Inside UserService.login, user ==> ", user);
      
      store.dispatch("loginUser", user);
      store.dispatch("replaceCompanies", user.companies)
      return user;
    });
  }

  signOff() {
    store.dispatch("logout"); // vuex
  }

  // logout - just clear userUUIDD in order to trigger re-login, so as to preserve the session
  logout() {
    store.dispatch("logout"); // vuex
  }
}

export default new AuthService();